/* eslint-disable react-hooks/exhaustive-deps */
import React from "react"
// wijmo
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
import queryString from "query-string"
import { useEffect, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
// import { useDispatch } from "react-redux"
import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
// import { AppDispatch } from "../.."
import AlertComponent from "../../../components/AlertComponent"
import ComboBox from "../../../components/ComboBox"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
// import ConfirmModal from "../../components/ConfirmModal"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"

import {
  T年ComboBoxItem,
  YearComboBox,
} from "../../../components/ComboBox/YearComboBox"
import VALIDATE_CONSTANT from "../../../constant/validateConstant"
import { RootState } from "../../../globalStore/rootreducer"
import {
  TZyomuinKoteihiListGetReq,
  T乗務員固定費,
} from "../../../service/driverpayroll/ZyomuinKoteihi/TZyomuinKoteihi"
import ZyomuinKoteihiService from "../../../service/driverpayroll/ZyomuinKoteihi/zyomuinKoteihiService"
import BusyoService from "../../../service/master/busyo/busyoService"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import commonUtil from "../../../ts/util/commonUtil"
import { TWijmoComboBox } from "../../../type/wijmoComponents"
import dateUtil, { TMonthNumber } from "../../../ts/util/dateUtil"
import _ from "lodash"
import dayjs from "dayjs"

type T月別固定費 = {
  固定費_4月: number
  固定費_5月: number
  固定費_6月: number
  固定費_7月: number
  固定費_8月: number
  固定費_9月: number
  固定費_10月: number
  固定費_11月: number
  固定費_12月: number
  固定費_1月: number
  固定費_2月: number
  固定費_3月: number
}
type T集計データ = {
  部所ID: number
  所属部所コード: string
  部所略称: string
  社員コード: string
  sort_社員コード: string
  社員氏名: string
  固定費_年度合計: number
} & T月別固定費

const ZyomuinKoteihiList: React.FC = (props) => {
  const history = useHistory()
  const location = useLocation()

  const 営業日 = useSelector((state: RootState) => state.date.eigyobiStr)
  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)
  const 当年度 = dateUtil.to年度(営業日)

  //TODO:ページ名称確定必須
  let gridId = "ZyomuinKoteihiList_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<T乗務員固定費>,
    pageSize: number
  ) => {
    let 集計データList: T集計データ[] = []
    const 乗務員別固定費groups = _.groupBy(
      data,
      (item) => `${item.社員コード}-${item.所属部所コード}`
    )
    for (let key in 乗務員別固定費groups) {
      const 乗務員別固定費group = 乗務員別固定費groups[key]

      const 集計データ: T集計データ = {
        部所ID: 乗務員別固定費group[0].部所ID,
        所属部所コード: 乗務員別固定費group[0].所属部所コード,
        部所略称: 乗務員別固定費group[0].部所略称,
        社員コード: 乗務員別固定費group[0].社員コード,
        sort_社員コード: commonUtil.createSortString(
          乗務員別固定費group[0].社員コード,
          VALIDATE_CONSTANT.LENGTH.社員コード
        ),
        社員氏名: 乗務員別固定費group[0].社員氏名,
        固定費_年度合計: 0,
        固定費_4月: 0,
        固定費_5月: 0,
        固定費_6月: 0,
        固定費_7月: 0,
        固定費_8月: 0,
        固定費_9月: 0,
        固定費_10月: 0,
        固定費_11月: 0,
        固定費_12月: 0,
        固定費_1月: 0,
        固定費_2月: 0,
        固定費_3月: 0,
      }

      for (let 乗務員別固定費 of 乗務員別固定費group) {
        const 月 = (dayjs(乗務員別固定費.給与支給年月).month() +
          1) as TMonthNumber
        const propertyName = `固定費_${月}月` as keyof T月別固定費
        集計データ[propertyName] += 乗務員別固定費.支給合計
        集計データ.固定費_年度合計 += 乗務員別固定費.支給合計
      }

      集計データList.push(集計データ)
    }
    集計データList = _.orderBy(
      集計データList,
      ["所属部所コード", "sort_社員コード"],
      ["asc", "asc"]
    )

    return new wjCore.CollectionView(集計データList, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })
  }

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TZyomuinKoteihiListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TZyomuinKoteihiListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    try {
      const res = await new ZyomuinKoteihiService().getList(
        currentSearchCondition
      )

      //表示用の検索条件を作成
      setDisplaySearchCondition(
        createDisplaySearchCondition(currentSearchCondition)
      )

      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data, pageSize) })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TZyomuinKoteihiListGetReq = queryString.parse(location.search)
    const 年度Inner = query.年度 as unknown as string
    set部所コード(query.部所コード ?? "")
    set年度(
      wjCore.isNullOrWhiteSpace(年度Inner ?? "") &&
        Number.isNaN(parseInt(年度Inner ?? ""))
        ? 当年度
        : parseInt(年度Inner ?? "")
    )
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TZyomuinKoteihiListGetReq => {
    return {
      部所コード: 部所コード ?? "",
      年度: 年度 ?? 当年度,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TZyomuinKoteihiListGetReq
  ) => {
    return {
      年度:
        searchCondition.年度 != null
          ? `${searchCondition.年度}年度`
          : undefined,
      部所: 部所ItemSource?.find(
        (i) => i.部所コード === searchCondition.部所コード
      )?.部所略称,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
  }

  const clearSearchState = () => {
    set部所コード("")
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {}

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  // ComboBox制御
  const [comboDataInitialized, setComboDataInitialized] =
    useState<boolean>(false)

  //#endregion

  //#region [state]
  const [部所コード, set部所コード] = useState<string | null>(null)

  // 部所
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [部所IsLoadEnded, set部所IsLoadEnded] = useState<boolean>(false)
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()

  const [年度, set年度] = useState<number | null>()

  // 年度
  const [年度ComboBox, set年度ComboBox] = useState<TWijmoComboBox<
    number | undefined,
    T年ComboBoxItem
  > | null>(null)
  const [年度isLoadEnded, set年度isLoadEnded] = useState<boolean>(false)

  //#endregion

  //#region [effect]
  //初期設定
  useEffect(() => {
    Promise.all([new BusyoService().getList({})]).then(([部所ListRes]) => {
      set部所ItemSource(部所ListRes.data)
    })
  }, [])

  useEffect(() => {
    if (!部所IsLoadEnded || !部所IsLoadEnded) return

    setComboDataInitialized(true)
  }, [部所IsLoadEnded, 部所IsLoadEnded])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && comboDataInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        set年度(当年度)
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized, comboDataInitialized])

  useEffect(() => {
    document.title = `社員マスタ一覧`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])
  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">乗務員固定費一覧</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-90rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <div className="w-8rem">
                              <YearComboBox
                                placeholder="年度"
                                is年度={true}
                                isLoadEnded={年度isLoadEnded}
                                isRequired={false}
                                setIsLoadEnded={set年度isLoadEnded}
                                selectedValue={年度}
                                setSelectedValue={(v) => {
                                  set年度(v)
                                }}
                                ComboBox={年度ComboBox}
                                setComboBox={set年度ComboBox}></YearComboBox>
                            </div>
                            <ComboBox.Busyo
                              autoFocus={true}
                              placeholder="部所"
                              isAllSelect={true}
                              itemsSource={部所ItemSource}
                              isLoadEnded={部所IsLoadEnded}
                              setIsLoadEnded={set部所IsLoadEnded}
                              listFilter={(d) => d.運行部所フラグ === 1}
                              selectedValue={部所コード}
                              setSelectedValue={set部所コード}
                              ComboBox={部所ComboBox}
                              setComboBox={set部所ComboBox}></ComboBox.Busyo>
                          </div>
                          <div className="search-condition-row">
                            <Button
                              type="submit"
                              disabled={isSearching}
                              onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                search()
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                              検索
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}>
                <wjrGrid.FlexGridColumn
                  binding="部所略称"
                  width={108}
                  header="所属部所"
                  sortMemberPath={"所属部所コード"}></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="社員コード"
                  width={90}
                  sortMemberPath="sort_社員コード"
                  header="社員CD"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="社員氏名"
                  width={108}
                  header="氏名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="固定費_年度合計"
                  width={100}
                  align={"right"}
                  header="合計"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="固定費_4月"
                  width={100}
                  align={"right"}
                  header="4月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="固定費_5月"
                  width={100}
                  align={"right"}
                  header="5月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="固定費_6月"
                  width={100}
                  align={"right"}
                  header="6月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="固定費_7月"
                  width={100}
                  align={"right"}
                  header="7月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="固定費_8月"
                  width={100}
                  align={"right"}
                  header="8月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="固定費_9月"
                  width={100}
                  align={"right"}
                  header="9月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="固定費_10月"
                  width={100}
                  align={"right"}
                  header="10月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="固定費_11月"
                  width={100}
                  align={"right"}
                  header="11月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="固定費_12月"
                  width={100}
                  align={"right"}
                  header="12月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="固定費_1月"
                  width={100}
                  align={"right"}
                  header="1月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="固定費_2月"
                  width={100}
                  align={"right"}
                  header="2月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="固定費_3月"
                  width={100}
                  align={"right"}
                  header="3月"></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default ZyomuinKoteihiList
